module.exports = {
          srcSet: __webpack_public_path__ + "public/18e80a3a6f37ecd48717e097166bb116-1024.png"+" 1024w",
          images:[ {path: __webpack_public_path__ + "public/18e80a3a6f37ecd48717e097166bb116-1024.png",width: 1024,height: 1024}],
          src: __webpack_public_path__ + "public/18e80a3a6f37ecd48717e097166bb116-1024.png",
          toString:function(){return __webpack_public_path__ + "public/18e80a3a6f37ecd48717e097166bb116-1024.png"},
          
          width: 1024,
          height: 1024
        }